import React from 'react';
import { clearSession } from '../utils/session';

// React 렌더 중 발생하는 예외를 포착해 흰 화면 대신 안내 화면을 보인다.
// componentDidCatch 에서 서버로 오류를 fire-and-forget 방식으로 보고한다.
export default class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: (error && error.message) || '알 수 없는 오류' };
    }

    componentDidCatch(error, errorInfo) {
        // 서버에 익명 오류 리포트 전송 (실패해도 사용자 화면에 영향 없음)
        try {
            const body = JSON.stringify({
                page: window.location.pathname,
                message: (error && error.message) || String(error),
                stack: (error && error.stack ? String(error.stack).slice(0, 500) : ''),
                userAgent: navigator.userAgent,
                ts: Date.now(),
            });
            fetch('/api/client-error', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body,
                keepalive: true,
            }).catch(() => {});
        } catch (e) { /* fire-and-forget */ }
    }

    handleReset = () => {
        try { clearSession(); } catch (e) { /* noop */ }
        window.location.replace('/Login');
    };

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                minHeight: '100vh', fontFamily: 'sans-serif', color: '#333', padding: '24px'
            }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
                <h1 style={{ margin: '0 0 12px', fontSize: 24 }}>문제가 발생했습니다</h1>
                <p style={{ margin: '0 0 8px', textAlign: 'center' }}>
                    화면을 그리는 도중 오류가 감지되었습니다. 다시 로그인해 주세요.
                </p>
                <p style={{ margin: '0 0 24px', fontSize: 12, color: '#888' }}>
                    문제가 반복되면 관리자에게 문의해 주세요.
                </p>
                <button
                    onClick={this.handleReset}
                    style={{
                        padding: '12px 32px', fontSize: 16, cursor: 'pointer',
                        background: '#008080', color: '#fff', border: 'none', borderRadius: 8
                    }}
                >
                    다시 로그인
                </button>
            </div>
        );
    }
}
